module.exports = __webpack_public_path__ + "static/c-2a47002f81625a7b866ff435ab632d11.jpg";